{
  "SYSTEM_STATUS_MESSAGE": {
    "OK": "Everything is ok",
    "INFO": "Everything is ok",
    "FAULT": "",
    "WARNING": ""
  }
}
